module.exports = __webpack_public_path__ + "img/Braai.a2dc06ab.jpg";